<template>
  <div style="text-align: center">
    <el-transfer v-model="value"
                 :left-default-checked="[]"
                 :right-default-checked="[]"
                 :render-content="renderFunc"
                 :titles="['选择项目', '已选项目']"
                 :button-texts="['到左边', '到右边']"
                 :format="{
                   noChecked: '${total}',
                   hasChecked: '${checked}/${total}'
                 }"
                 :data="data"
                 style="text-align: left; display: inline-block"
                 filterable
                 @change="handleChange">
      <div slot="right-footer">
        <el-button size="small"
                   @click="closeDialog">取消</el-button>
        <el-button size="small"
                   type="primary"
                   @click="getProjectName">确定</el-button>
      </div>

    </el-transfer>
  </div>
</template>

<script>
export default {
  name: 'Index',
  props: {
    data: {
      type: Object,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      value: [1],
      value4: [1],
      renderFunc(h, option) {
        return <span>{option.key} - {option.label}</span>
      }
    }
  },
  computed: {

  },
  methods: {

    handleChange(value, direction, movedKeys) {
      console.log(this.value, '******')
      console.log(this.value4, '***dddd***')
    },
    closeDialog() {
      this.$emit('closeDialog', false)
    },
    getProjectName() {
      this.$message({
        type: 'success',
        message: `获取项目名称${this.value}`
      })
    }
  }
}
</script>

<style scoped>
</style>
